<template>
    <div>
        <div class="login-top flex flex-center-cz">
            <div class="font-xl font-bold" style="margin-left: 100px;">量子文档</div>
        </div>
        <div class="login-body flex">
            <div class="half-width flex flex-col flex-center-cz">
                <img style="width: 280px;height: 280px; margin-top: 150px;" src="@/assets/images/login-file2.png"/>
                <div class="margin-top-m">极简在线文档处理工具，一键分享、文档分身，多人编辑生成各自版本</div>
                <div class="margin-top-m">电脑端 + 小程序端同步使用，不受空间限制，随时随地分享</div>
                <div class="margin-top-m">写测试文档，做调查问卷，制作试卷，记录错题，写日记，记便签，处理待办等</div>
                <div class="margin-top-m">点赞、评论、互动，让文档建立起沟通桥梁</div>                
            </div>
            <div v-if="loginType=='wx'" class="half-width flex flex-col flex-center-cz">
                <div class="font-xl font-bold" style="margin-top: 230px;">微信扫码安全登录</div>
                <div class="font-s margin-top-m color-gray" >扫描关注『量子文档』，完成登录</div>
                <img class="margin-top-xl" style="width: 200px;height: 200px;" :src="imageUrl" v-if="imageUrl != ''"/>
                <div class="margin-top-xl btn-white-full w150 border-radius-xxl pointer font-s" @click="userlogin">账号登录</div>
            </div>
            <div v-if="loginType=='mobile'" class="half-width flex flex-col flex-center-cz">
                <div class="font-xl font-bold" style="margin-top: 230px;">手机号码登录</div>
                <div  style="width: 300px;margin-top: 50px;"> 
                    <input class="ui-input full-width" type="text" placeholder="请输入手机号" v-model="phone"/>
                </div>
                <div class="margin-top-l ui-input flex flex-space-between flex-center-cz w300 " style="background-color: #fff;"> 
                    <input style="border: 0; width: 200px;" type="text" placeholder="请输入登录密码" v-model="password"/>
                    <div class="font-s color-blue pointer" @click="sms">发送验证码</div>
                </div>
                
                <div class="margin-top-l btn-blue-full border-radius-xxl pointer font-s w300"   @click="loginM">登录</div>
                <div class="margin-top-xl font-s" >登录即代表你同意量子文档相关 <span class="color-blue">服务条款</span> 和 <span class="color-blue">隐私协议</span>  </div>
                <div class="margin-top-xl btn-white-full border-radius-xxl pointer font-s w300"   @click="wxlogin">微信登录</div>
            </div>
            <div v-if="loginType=='user'" class="half-width flex flex-col flex-center-cz">
                <div class="font-xl font-bold" style="margin-top: 230px;">账号登录</div>
                <div  style="width: 300px;margin-top: 50px;"> 
                    <input class="ui-input full-width" type="text" placeholder="请输入登录账号" v-model="username"/>
                </div>
                <div class="margin-top-l ui-input flex flex-space-between flex-center-cz w300 " style="background-color: #fff;"> 
                    <input style="border: 0; width: 200px;" type="password" placeholder="请输入登录密码" v-model="password"/>
                </div>               
                <div class="margin-top-l btn-blue-full border-radius-xxl pointer font-s w300"   @click="loginUser">登录</div>
                <div class="margin-top-xl font-s" >登录即代表你同意量子文档相关 <span class="color-blue">服务条款</span> 和 <span class="color-blue">隐私协议</span>  </div>
                <div class="margin-top-xl btn-white-full border-radius-xxl pointer font-s w300"   @click="wxlogin">微信登录</div>
            </div>


        </div>
    </div>
</template>

<script>

import * as utils from "@/utils/httpUtils.js"
import config from '@/config/index.js'
import {getTempQrCode,checkScanState,updateRealname} from '@/api/api.js';
import {getShareToken,objToStr} from '@/utils/sysUtils'


export default {
  name: 'Login',
  data() {
      return {  
          token: getShareToken(12),
          loginType: config.configData.loginType,
          imageUrl:"",
          phone:"",
          username:"",
          password:""    
      }
  },
  created() {

        sessionStorage.setItem('token', "")
        sessionStorage.setItem('userId', "")
        sessionStorage.setItem('userName', "")
        sessionStorage.setItem('realname', "")

        localStorage.setItem('token', "")
        localStorage.setItem('userId', "")
        localStorage.setItem('userName', "")
        localStorage.setItem('realname', "")

        if (this.loginType == "wx") {
            this.wxlogin();
        } 
     //this.$closeLoading();
  },
  methods:{
    wxlogin() {
        this.$showLoading();
        getTempQrCode(this.token).then((res) => {
            console.log("res==========",res);
            this.$closeLoading();
            this.imageUrl = objToStr(res.data.message);
            this.loginType='wx'
            setTimeout(() => {
                this.check();               
            }, 1000);
        }) 
    },
    userlogin() {
        this.loginType='user'
    },
    mobilelogin() {
        this.loginType='mobile'
    },
    sms() {

        console.log(config.configData);
        if (this.phone == "") {
            this.$showToast({msg: '手现号未填写' });
            return;
        }
        let url = config.configData.api_url + "/sys/sms";
        let param = {"mobile":this.phone ,"smsmode":1 };
        this.$showLoading();
        utils.httpPost(url, param).then((res) => {
          console.log(res.data);
          this.$closeLoading();
          if (res.data.success == true) {
            this.$showToast({msg: '验证码已发送！' });
            return false;
          } else {
            this.$showToast({msg: res.data.message});
            return false;
            
          }
        })
    },
    loginUser(){
        if (this.username == "") {
            this.$showToast({msg: '账号未填写' });
            return;
        }
        if (this.password == "") {
            this.$showToast({msg: '密码未填写'});
            return;
        }
        this.$showLoading();
        let param = {"username":this.username ,"password":this.password  };
        let url = config.configData.api_url + "/sys/loginUser";
        utils.httpPost(url, param).then((res) => {
          console.log(res.data.result);
          this.$closeLoading();
          if (res.data.success == true) {
            sessionStorage.setItem('token', res.data.result.token)
            sessionStorage.setItem('userId', res.data.result.userInfo.id)
            sessionStorage.setItem('userName', res.data.result.userInfo.username)
            sessionStorage.setItem('realname', res.data.result.userInfo.realname)
            sessionStorage.setItem('sex', res.data.result.userInfo.sex)
            sessionStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
            sessionStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

            localStorage.setItem("token", res.data.result.token);
            localStorage.setItem("userId", res.data.result.userInfo.id);
            localStorage.setItem('sex', res.data.result.userInfo.sex)
            localStorage.setItem("userName", res.data.result.userInfo.username);
            localStorage.setItem("realname", res.data.result.userInfo.realname);
            localStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
            localStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

            this.$router.push({
              path: '/person' ,
            })
          } else {
            this.$showToast({msg: res.data.message});
            return;
            
          }
        })

    },
    loginM(){
        if (this.phone == "") {
            this.$showToast({msg: '手机号未填写' });
            return;
        }
        if (this.password == "") {
            this.$showToast({msg: '密码未填写'});
            return;
        }
        this.$showLoading();
        let param = {"mobile":this.phone ,"captcha":this.password  };
        let url = config.configData.api_url + "/sys/phoneLogin";
        utils.httpPost(url, param).then((res) => {
          console.log(res.data.result);
          this.$closeLoading();
          if (res.data.success == true) {
            sessionStorage.setItem('token', res.data.result.token)
            sessionStorage.setItem('userId', res.data.result.userInfo.id)
            sessionStorage.setItem('userName', res.data.result.userInfo.username)
            sessionStorage.setItem('realname', res.data.result.userInfo.realname)
            sessionStorage.setItem('sex', res.data.result.userInfo.sex)
            sessionStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
            sessionStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

            localStorage.setItem("token", res.data.result.token);
            localStorage.setItem("userId", res.data.result.userInfo.id);
            localStorage.setItem('sex', res.data.result.userInfo.sex)
            localStorage.setItem("userName", res.data.result.userInfo.username);
            localStorage.setItem("realname", res.data.result.userInfo.realname);
            localStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
            localStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

            this.$router.push({
              path: '/person' ,
            })
          } else {
            this.$showToast({msg: res.data.message});
            return;
            
          }
        })

    },
    check() {
        if (this.loginType!='wx') return false;       
        checkScanState(this.token).then((res) => {
            console.log(res);
            console.log("check....");
            if (res.data.success == true) {
                sessionStorage.setItem('token', res.data.result.token)
                sessionStorage.setItem('userId', res.data.result.userInfo.id)
                sessionStorage.setItem('userName', res.data.result.userInfo.username)
                sessionStorage.setItem('realname', res.data.result.userInfo.realname)
                sessionStorage.setItem('sex', res.data.result.userInfo.sex)
                sessionStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
                sessionStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

                localStorage.setItem("token", res.data.result.token);
                localStorage.setItem("userId", res.data.result.userInfo.id);
                localStorage.setItem('sex', res.data.result.userInfo.sex)
                localStorage.setItem("userName", res.data.result.userInfo.username);
                localStorage.setItem("realname", res.data.result.userInfo.realname);
                localStorage.setItem('memberLevelName', res.data.result.memberLevel.name)
                localStorage.setItem('maxFileCount', res.data.result.memberLevel.maxFileCount)

                this.loginType = "";
                if (objToStr(res.data.result.userInfo.realname) == "") {
                    this.$showInputBox({
                        caption: "输入您的姓名",
                        inputValue: '',
                        callback: (data) => {
                            updateRealname(res.data.result.userInfo.id, data).then((res) => {
                                sessionStorage.setItem('realname', data)
                                this.$closeInputBox();    
                            })
                        }
                    })
                }
                this.$router.push({
                    path: '/person' ,
                })
            } else {               
                setTimeout(() => {
                    this.check();               
                }, 1000);
            }
        })           
    },



  }
}
</script>

<style scoped>

.login-top {
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      top:0px;
      width: 100%;
      position: fixed;
      height: 60px;
      text-align: left;
      border-bottom: 1px solid rgba(0, 0, 0, .1);
    }
.login-body {
    position: fixed;
    top:60px;
    bottom: 0;
    left:0;
    right: 0;

}    


</style>



// WEBPACK FOOTER //
// src/views/Login.vue